<template>
  <div>
    <div>
      <v-card flat class="py-12 px-10">
        <div ref="pdfContent">
          <v-card class="d-flex justify-start px-6" flat>
            <img src="../../assets/images/iba-logo.svg" width="130" height="90" alt="">
          </v-card>

          <div class="px-6">
            <div>
              <div class="my-2">
                <div class="heading-3">Invoice</div>
                <div class="d-flex items-center my-2 light-content" style="justify-content:space-between">
                  <div>
                    <span class="">Order number: {{invoiceRecord.OrderCode}}</span>
                  </div>
                  <div>{{ formatDate }}</div>
                </div>
                <div>
                  <span class="light-content"> Issued to: {{ GetPreviewUser.Email }}</span>
                </div>
              </div>
            </div>
            <v-divider style="border:1px solid black"> </v-divider>
            <span class="heading-3 mt-4">Charges*</span>
            <div>
              <i class="mt-2 light-content">*All prices in US Dollar.</i>
            </div>
            <div class="light-content">
              <div class="my-8">
                <div class="d-flex justify-space-between">
                  <span>Membership Payment: <b>{{ getMembershipLabel(invoiceRecord.MembershipID) }}</b></span>
                  <span v-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Starter'">$ 0.00</span>
                  <span v-else-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Access'">$ 40.00</span>
                  <span v-else-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Standard'">$ 150.00</span>
                  <span v-else-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Practitioner'">$ 300.00</span>
                  <span v-else-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Instructor' || 'Senior Instructor'">$ 300.00</span>
                </div>
                <div>
                  Membership period: <b>{{ invoiceRecord.DateProcessed?.split("T")[0].replaceAll('-','/') }} to {{ oneYearLater }}</b>
                </div>
              </div>
              <v-row class="mb-8">
                <v-col cols="12" md="5"></v-col>
                <v-col cols="12" md="7">
                  <div class="d-flex justify-space-between"><span>Prorated Adjustment:</span>	<span>$ {{ invoiceRecord.ProratedAdjustment?.toFixed(2) }}</span></div>
                  <div class="d-flex justify-space-between"><span>Discount: </span>	<span>$ {{ couponDiscountValue }}</span></div>
                  <div v-if="invoiceRecord.MemberLocation == 'Brazil' || invoiceRecord.MemberLocation == 'Japan'" class="d-flex justify-space-between"><span>{{invoiceRecord.MemberLocation}} Discount: </span>	<span>$ {{ invoiceRecord.LocationDiscount?.toFixed(2) }}</span></div>
                  <!-- <div v-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Instructor'" class="d-flex justify-space-between"><span>License Fee: </span>	<span>$ {{ GetInstructorLicensingDetails?.TotalLicencingFees?.toFixed(2) }}</span></div> -->
                  <div v-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Instructor' || 'Senior Instructor'" class="d-flex justify-space-between"><span>License Fee: </span>	<span>$ {{ (invoiceRecord.LicensingFee || 0)?.toFixed(2) }}</span></div>
                  <!-- <div v-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Instructor'" class="d-flex justify-space-between"><span>Total Credits Earned: </span>	<span>$ {{ getMembershipByUserId?.InstructorPreviousRecord?.CreditsEarned.toFixed(2) }}</span></div> -->
                  <div v-if="getMembershipLabel(invoiceRecord.MembershipID) === 'Instructor' || 'Senior Instructor'" class="d-flex justify-space-between"><span>Total Credits Earned: </span>	<span>$ {{ (invoiceRecord.TotalCreditsEarned || 0)?.toFixed(2) }}</span></div>
                  <div class="d-flex justify-space-between"><span>Total:</span>	<span>$ {{invoiceRecord.Amount?.toFixed(2)}}</span></div>
                  <div class="d-flex justify-space-between"><b><span>Paid:</span></b>	<b><span>$ {{invoiceRecord.Amount?.toFixed(2)}}</span></b></div>
                </v-col>
              </v-row>
              <div>
                <b>Payment Method:</b> <span v-if="invoiceRecord.PaymentMethod === 'Offline Payment'">
                  ADMIN
                </span><span v-else>
                  {{ maskCardNumber(invoiceRecord.CardNumber) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="d-flex justify-space-between mx-5 py-14 px-10">
          <div class="d-flex justify-start">
            
          </div>
          <v-btn
            depressed
            color="primary"
            class="px-6 py-6"
            @click="downloadPDF()"
          >
            Print
            <v-icon class="px-3 d-flex justify-end"> mdi-printer </v-icon>
          </v-btn>
        </div> -->
      </v-card>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import { mapGetters } from "vuex";
export default {
  name: "seeprofilecomponent",
  computed: {
    ...mapGetters(["GetPreviewUser", "getMembershipByUserId"]),
    formatDate() {
      const date = new Date(this.invoiceRecord?.DateProcessed);

      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    },
    oneYearLater() {
      if (this.invoiceRecord?.MembershipEndDate) {
        // Split the raw string like DateProcessed above instead of going
        // through Date/toISOString, which would UTC-shift a timezone-less
        // date string back a day for viewers west of Greenwich.
        return this.invoiceRecord.MembershipEndDate.split("T")[0].replaceAll('-', '/');
      }
      // Older invoices predate the MembershipEndDate column, so fall back to
      // the naive DateProcessed + 1 year using local date parts.
      const date = new Date(this.invoiceRecord?.DateProcessed);
      date.setFullYear(date.getFullYear() + 1); // Add one year
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    },
    couponDiscountValue() {
  if (this.invoiceRecord && this.invoiceRecord.Coupon) {
    const discount = this.invoiceRecord.Coupon.DiscountValue;
    const discountType = this.invoiceRecord.Coupon.DiscountType;

    // Determine the membership value based on MembershipID
    const membershipValue = (() => {
      switch (this.getMembershipLabel(this.invoiceRecord.MembershipID)) {
        case "Starter":
          return 0;
        case "Access":
          return 40;
        case "Standard":
          return 150;
        case "Practitioner":
          return 300;
        case "Instructor":
          return 300;
        default:
          return 0;
      }
    })();

    return discountType === 1
      ? ((discount / 100) * membershipValue)?.toFixed(2)
      : discount?.toFixed(2);
  }

  return "0.00";
},
  },
  props: ["invoiceRecord", "getMembershipLabel", "GetInstructorLicensingDetails"],
  data() {
    return {
      date: "Wednesday, November 4, 2020",
      name: "Axel Camelitti",

      issued: "225 Varick Street, 15tf Floor New York, NY 10014",
      addess:
        "Remaining time Annually after Nov 4, 2020(bodytalk) 11/4/2020 - 5/22/2021",
      //addess1: "The charges should describe: [MEMBERSHIP LEVEL] - [Category - NEW/RENEWAL/UPGRADE] - Renewal period [DATE RANGE] - [IF PRORATED]",
      membershiplevel: "Practitioner Membership",
      category: "Renewal",
      amount: "$39.26",
      TAmount: "7453",
      dash: "--",
      mount: "$0.00",
      daterange: "11/4/2020 - 5/22/2021",
      tabs: null,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    };
  },
  methods: {
    maskCardNumber(cardNumber) {
      if (!cardNumber || (cardNumber.length !== 15 && cardNumber.length !== 16)) {
        return cardNumber; // Return the input if it's not valid
      }
      const visibleDigits = cardNumber.slice(-4); // Get the last 4 digits
      return '****' + visibleDigits; // Mask the rest
    },
    downloadPDF() {
      const element = this.$refs.pdfContent;
      const options = {
        margin: 1,
        filename: "invoice.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      };
      // Convert the HTML to a PDF
      html2pdf().from(element).set(options).save();
    },
  },
};
</script>

<style scoped>
.total_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;

  color: #222222;
}
.light-content {
  font-size: 20px;
  font-family: "DM Sans";
  font-weight: 400;
  color: #222222;
}
</style>
